<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span style="white-space: pre-line">{{message}}</span>
                </div>
            </div>
          <div class="button-wrap">
            <button @click="btnEvent('C')" class="button-bg-gray">닫기</button>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChargingPopup',
    data() {
      return {
      }
    },
    props:['message'],
    methods : {
      btnEvent(item) {
        this.$emit('emitPopValue', item)
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/chargingPopup2.scss';
</style>